module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ticket-info"
  }, [(_vm.getTicketType.type === 'group') ? _c('h5', {
    staticStyle: {
      "margin-left": "32px",
      "margin-bottom": "12px",
      "color": "#888"
    }
  }, [_vm._v("此票種報名人數需符合 " + _vm._s(_vm.getTicketType.min) + " - " + _vm._s(_vm.getTicketType.max) + " 人 (含隊長)")]) : _vm._e(), _c('h5', {
    staticStyle: {
      "margin-left": "32px",
      "color": "#888"
    }
  }, [_vm._v(_vm._s(_vm.isDdiving(_vm.getTicketType.desc)))]), _c('div', {
    staticClass: "mb-4"
  }), _c('div', {
    staticClass: "buyers-wrap"
  }, [_c('div', {
    staticClass: "buyer-info",
    class: {
      'leader': _vm.getTicketType.type === 'group'
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.getTicketType.type === 'group' ? '團長資訊' : '個人資訊'))]), _c('div', {
    staticClass: "input-row"
  }, [_c('div', {
    staticClass: "input-wrap col-xs-12 col-md-5"
  }, [_c('label', [_vm._v("帳號")]), _c('input', {
    attrs: {
      "type": "text",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.leaderInfo.account
    }
  })]), _c('div', {
    staticClass: "input-wrap col-xs-12 col-md-5",
    class: {
      warning: _vm.leaderInfo.isEmailAuth === false
    }
  }, [_c('label', [_vm._v("Email")]), _c('input', {
    attrs: {
      "type": "email",
      "disabled": "disabled"
    },
    domProps: {
      "value": _vm.leaderInfo.email
    }
  }), (_vm.leaderInfo.isEmailAuth === false) ? _c('small', {
    staticClass: "warn"
  }, [_vm._v("此Email尚未通過驗證，"), _c('a', {
    staticClass: "link-red",
    attrs: {
      "href": "https://www.4gamers.com.tw/member/player"
    }
  }, [_vm._v("前往驗證")])]) : _vm._e()])]), _c('div', {
    staticClass: "input-row"
  }, [_c('div', {
    staticClass: "input-wrap col-xs-12 col-md-5"
  }, [_c('label', [_vm._v("身份證末四碼")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim.lazy",
      value: (_vm.leaderInfo.idNumber),
      expression: "leaderInfo.idNumber",
      modifiers: {
        "trim": true,
        "lazy": true
      }
    }],
    staticClass: "idNumber",
    attrs: {
      "type": "text",
      "index": "leader"
    },
    domProps: {
      "value": (_vm.leaderInfo.idNumber)
    },
    on: {
      "keyup": _vm.checkValue,
      "change": function($event) {
        _vm.leaderInfo.idNumber = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('small', {
    staticClass: "warn"
  }, [_vm._v("* 外籍人士請提供護照末四碼")]), _c('small', {
    staticClass: "warn"
  }, [_vm._v("* 注意：請正確填寫身分證後四碼，我們將以此資料為入場驗證資料")])])])]), _c('transition-group', {
    attrs: {
      "name": "list"
    }
  }, _vm._l((_vm.members), function(buyer, index) {
    return (_vm.getTicketType.type === 'group') ? _c('div', {
      key: index,
      staticClass: "buyer-info"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("隊員 " + _vm._s(index + 1)), _c('div', {
      staticClass: "btn delete",
      on: {
        "click": function($event) {
          _vm.removeBuyer(index)
        }
      }
    }, [_c('div', {
      staticClass: "fa fa-times"
    }, [_c('span', {
      staticClass: "text"
    }, [_vm._v("刪除隊員")])])])]), _c('div', {
      staticClass: "input-row"
    }, [_c('div', {
      staticClass: "input-wrap col-xs-12 col-md-5",
      class: {
        warning: buyer.isAdult === false
      }
    }, [_c('label', [_vm._v("帳號")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim.lazy",
        value: (buyer.account),
        expression: "buyer.account",
        modifiers: {
          "trim": true,
          "lazy": true
        }
      }],
      attrs: {
        "type": "text",
        "disabled": "disabled"
      },
      domProps: {
        "value": (buyer.account)
      },
      on: {
        "change": function($event) {
          buyer.account = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), (buyer.isAdult === false) ? _c('small', {
      staticClass: "warn"
    }, [_vm._v("會員於活動期間未滿18歲，不可報名參加活動")]) : _vm._e()]), _c('div', {
      staticClass: "input-wrap col-xs-12 col-md-5",
      class: {
        warning: buyer.isEmailAuth === false
      }
    }, [_c('label', [_vm._v("Email")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim.lazy",
        value: (buyer.email),
        expression: "buyer.email",
        modifiers: {
          "trim": true,
          "lazy": true
        }
      }],
      attrs: {
        "type": "email",
        "disabled": "disabled"
      },
      domProps: {
        "value": (buyer.email)
      },
      on: {
        "change": function($event) {
          buyer.email = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    }), (buyer.isEmailAuth === false) ? _c('small', {
      staticClass: "warn"
    }, [_vm._v("此Email尚未通過驗證，請提醒隊員前往 https://www.4gamers.com.tw/member/player 驗證")]) : _vm._e()])]), _c('div', {
      staticClass: "input-row"
    }, [_c('div', {
      staticClass: "input-wrap col-xs-12 col-md-5"
    }, [_c('label', [_vm._v("身份證末四碼")]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim.lazy",
        value: (buyer.idNumber),
        expression: "buyer.idNumber",
        modifiers: {
          "trim": true,
          "lazy": true
        }
      }],
      ref: "idNumber",
      refInFor: true,
      staticClass: "idNumber",
      attrs: {
        "type": "text",
        "index": index
      },
      domProps: {
        "value": (buyer.idNumber)
      },
      on: {
        "keyup": function($event) {
          _vm.checkValue(index)
        },
        "change": function($event) {
          buyer.idNumber = $event.target.value.trim()
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })])])]) : _vm._e()
  }))], 1), (_vm.getTicketType.type === 'group' && _vm.members.length < _vm.getTicketType.max - 1) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "search-member col-xs-12"
  }, [_c('h3', [_vm._v("新增隊員")]), _c('div', {
    staticClass: "input-wrap",
    class: {
      'noResult': !_vm.ifResult
    }
  }, [_c('div', {
    staticClass: "input-valid-wrap"
  }, [_c('label', [_vm._v("搜尋帳號")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "keyup": [function($event) {
        _vm.searchAccount($event.target.value)
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "left", 37)) { return null; }
        if ('button' in $event && $event.button !== 0) { return null; }
        $event.preventDefault();
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "right", 39)) { return null; }
        if ('button' in $event && $event.button !== 2) { return null; }
        $event.preventDefault();
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), (this.searchInput.length > 0 && _vm.loading) ? _c('div', {
    staticClass: "status"
  }, [_vm._v("搜尋中...")]) : _vm._e(), (this.searchInput.length > 0 && !_vm.loading) ? _c('div', {
    staticClass: "btn clear-button",
    on: {
      "click": _vm.clearResult
    }
  }, [_vm._v("X")]) : _vm._e()])]), _c('ul', {
    staticClass: "options-dropdown"
  }, _vm._l((_vm.options), function(option, index) {
    return (index < 5) ? _c('li', {
      on: {
        "click": function($event) {
          _vm.getSelected(option.account, option.email, option.is_adult, option.is_email_auth)
        }
      }
    }, [_c('div', {
      staticClass: "account"
    }, [_vm._v(_vm._s(option.account))]), _c('div', {
      staticClass: "email"
    }, [_vm._v(_vm._s(option.email))])]) : _vm._e()
  }))])]) : _vm._e(), _c('hr'), _c('div', {
    staticClass: "btn-wrap"
  }, [_c('div', {
    staticClass: "btn ghost-btn pre-btn",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("上一步")]), _c('div', {
    staticClass: "btn ghost-btn next-btn",
    attrs: {
      "disabled": _vm.submitDisabled
    },
    on: {
      "click": _vm.submitInfo
    }
  }, [(_vm.submitDisabled) ? _c('div', {
    staticClass: "spinner"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("處理中")]), _c('div', {
    staticClass: "bounce bounce1"
  }), _c('div', {
    staticClass: "bounce bounce2"
  }), _c('div', {
    staticClass: "bounce bounce3"
  })]) : _c('span', [_vm._v("下一步")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75415fc4"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tickets/ticketInfo.vue
// module id = 572
// module chunks = 1